import {OptInDialogHeaderMrGreenBox} from "./opt-in-dialog-header.mrgreen.box";

export const OptInDialogHeaderMrGreenCisBox = OptInDialogHeaderMrGreenBox;